module.exports = __webpack_public_path__ + "static/media/B.f68809d4.svg";